// 篩選計算區。
export const getters = {
  // 輸入無效代號或 call API 伺服器失效，接收錯誤提示訊息。
  errorMessageWithFilterRate: state => state.errorMessage,

  filterRate: state => state.filterRate,

  // ------------------ FilterRateForm 輸出回傳值 ------------------

  // :value 因單向流需綁定輸出值，確保即時顯示與 state 當前資料同步。
  outputValueOfEBOIC: ({ ratio }) => ratio.EBOIC,
  outputValueOfGrossProfitRatio: ({ ratio }) => ratio.gross_profit_ratio,
  outputValueOfROIC: ({ ratio }) => ratio.ROIC,
  outputValueOfExpectedRateOfReturn: ({ ratio }) =>
    ratio.expected_rate_of_return,
  outputValueOfSelectLevel: ({ ratio }) => ratio.level,
  companyType: ({ ratio }) => ratio.go_public,
  stockSymbolInForm: ({ ratio }) => ratio.stock_symbol,

  // ------------------ 篩選表格區格式 ------------------

  // 符合條件，每筆分別進行基本資料格式轉換。
  itemsOfFilterRate: (
    state,
    { filterRate, roundDown1DecimalPlace, roundDown2DecimalPlace, formateToNA }
  ) => {
    return filterRate.map(
      ({
        year, // 未使用到，需過濾移除，如無清除，eslint 會提示宣告未使用錯誤。
        level,
        go_public,
        closing_price,
        net_value_per_share,
        net_value_ratio,
        discount_ratio,
        // per_share_EPS,
        EPS_of_recently_four_seasons, //近四季每股 EPS(元)
        EPS_price_earnings_ratio, //本益比
        sum_of_EBIDTA,
        // cash_reinvestment_ratio,
        // dividend_redistribution_ratio,
        gross_profit_ratio,
        EBOIC,
        ROIC,
        share_capital, //股本
        market_capital, //市值
        EBPR, //EBPR
        // EBOE,
        // ROE,
        // EBOA,
        // ROA,
        ...pairs
      }) => {
        delete [year]; // 如無清除，eslint 會提示宣告未使用錯誤。
        return {
          level: level || "-",
          go_public: go_public,
          closing_price: roundDown1DecimalPlace(closing_price),
          net_value_per_share: roundDown1DecimalPlace(net_value_per_share),
          //淨值比 net_value_ratio 顯示到小數第二位
          net_value_ratio: roundDown2DecimalPlace(net_value_ratio),
          discount_ratio: roundDown1DecimalPlace(discount_ratio),
          // per_share_EPS: roundDown1DecimalPlace(per_share_EPS),
          EPS_of_recently_four_seasons: EPS_of_recently_four_seasons === null ? formateToNA() : roundDown1DecimalPlace(
            EPS_of_recently_four_seasons
          ),

          EPS_price_earnings_ratio: EPS_price_earnings_ratio === null ? formateToNA() : roundDown1DecimalPlace(
            EPS_price_earnings_ratio
          ),
          sum_of_EBIDTA: sum_of_EBIDTA === null ? formateToNA() : roundDown1DecimalPlace(sum_of_EBIDTA),
          // cash_reinvestment_ratio: roundDown1DecimalPlace(cash_reinvestment_ratio),
          // dividend_redistribution_ratio: roundDown1DecimalPlace(
          //   dividend_redistribution_ratio
          // ),
          gross_profit_ratio: roundDown1DecimalPlace(gross_profit_ratio),
          EBOIC: roundDown1DecimalPlace(EBOIC),
          ROIC: roundDown1DecimalPlace(ROIC),
          share_capital: share_capital,
          market_capital: roundDown1DecimalPlace(market_capital),
          //EBPR 顯示到小數第二位
          EBPR: EBPR === null ? formateToNA() : roundDown2DecimalPlace(EBPR),
          // EBOE: roundDown1DecimalPlace(EBOE),
          // ROE: roundDown1DecimalPlace(ROE),
          // EBOA: roundDown1DecimalPlace(EBOA),
          // ROA: roundDown1DecimalPlace(ROA),
          ...pairs
        };
      }
    );
  },
  // 保留到小數點第一位，之後無條件捨去。
  roundDown1DecimalPlace: () => field => Math.floor(field * 10) / 10,
  // 保留到小數點第二位，之後無條件捨去。
  roundDown2DecimalPlace: () => field => Math.floor(field * 100) / 100,
  formateToNA: () => ()=> 'NA',

  filterOptions: state => state.filterOptions,
  whatQueryDataToGetBySelectedFilterOptions: ({ filterOptions, ratio }) => {
    const {
      expected_rate_of_return,
      level,
      go_public,
      EBOIC,
      ROIC,
      gross_profit_ratio
    } = ratio;
    console.log(">>> ", filterOptions);

    if (filterOptions.selectStock) {
      console.log(">>>> 1");
      return {
        query: null,
        emitName: "submitACompanyByStock",
        actionName: "fetchACompanyByStock"
      };
    } else if (
      !filterOptions.selectStock &&
      !filterOptions.selectEBOIC &&
      !filterOptions.selectROIC &&
      !filterOptions.selectProfitRatio
    ) {
      console.log(">>>> 2");
      return {
        query: null,
        emitName: "submitCompanyByDefault",
        actionName: "fetchCompanyByDefault"
      };
    } else if (
      !filterOptions.selectStock &&
      filterOptions.selectEBOIC &&
      filterOptions.selectROIC &&
      filterOptions.selectProfitRatio
    ) {
      console.log(">>>> 3");
      // default + EBOIC、ROIC、毛利率
      const query = new URLSearchParams({
        expected_rate_of_return,
        level,
        go_public,
        EBOIC,
        ROIC,
        gross_profit_ratio
      });
      return {
        query: query.toString(),
        emitName: "submitCompanyByRatioAndDefault",
        actionName: "fetchCompanyBySelectedFilterOptions"
      };
    } else if (
      !filterOptions.selectStock &&
      filterOptions.selectEBOIC &&
      filterOptions.selectROIC
    ) {
      console.log(">>>> 4");
      // default + EBOIC、ROIC
      const query = new URLSearchParams({
        expected_rate_of_return,
        level,
        go_public,
        EBOIC,
        ROIC
      });
      return {
        query: query.toString(),
        emitName: "submitCompanyByRatioAndDefault",
        actionName: "fetchCompanyBySelectedFilterOptions"
      };
    } else if (
      !filterOptions.selectStock &&
      filterOptions.selectEBOIC &&
      filterOptions.selectProfitRatio
    ) {
      console.log(">>>> 5");
      // default + EBOIC、毛利率
      const query = new URLSearchParams({
        expected_rate_of_return,
        level,
        go_public,
        EBOIC,
        gross_profit_ratio
      });
      return {
        query: query.toString(),
        emitName: "submitCompanyByRatioAndDefault",
        actionName: "fetchCompanyBySelectedFilterOptions"
      };
    } else if (
      !filterOptions.selectStock &&
      filterOptions.selectROIC &&
      filterOptions.selectProfitRatio
    ) {
      console.log(">>>> 6");
      // default + ROIC、毛利率
      const query = new URLSearchParams({
        expected_rate_of_return,
        level,
        go_public,
        ROIC,
        gross_profit_ratio
      });
      return {
        query: query.toString(),
        emitName: "submitCompanyByRatioAndDefault",
        actionName: "fetchCompanyBySelectedFilterOptions"
      };
    } else if (!filterOptions.selectStock && filterOptions.selectEBOIC) {
      console.log(">>>> 7");
      // default + EBOIC
      const query = new URLSearchParams({
        expected_rate_of_return,
        level,
        go_public,
        EBOIC
      });
      return {
        query: query.toString(),
        emitName: "submitCompanyByRatioAndDefault",
        actionName: "fetchCompanyBySelectedFilterOptions"
      };
    } else if (!filterOptions.selectStock && filterOptions.selectROIC) {
      console.log(">>>> 8");
      // default + ROIC
      const query = new URLSearchParams({
        expected_rate_of_return,
        level,
        go_public,
        ROIC
      });
      return {
        query: query.toString(),
        emitName: "submitCompanyByRatioAndDefault",
        actionName: "fetchCompanyBySelectedFilterOptions"
      };
    } else if (!filterOptions.selectStock && filterOptions.selectProfitRatio) {
      console.log(">>>> 9");
      // default + 毛利率
      const query = new URLSearchParams({
        expected_rate_of_return,
        level,
        go_public,
        gross_profit_ratio
      });
      return {
        query: query.toString(),
        emitName: "submitCompanyByRatioAndDefault",
        actionName: "fetchCompanyBySelectedFilterOptions"
      };
    } else {
      console.log(">>>> 10");
      return {
        query: null,
        emitName: "submitCompanyByDefault",
        actionName: "fetchCompanyByDefault"
      };
    }
  }
};
